//按需引入element组件
import {
  Autocomplete,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Radio,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  Popover,
  Tooltip,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Icon,
  Row,
  Col,
  Upload,
  Badge,
  Card,
  Carousel,
  CarouselItem,
  Divider,
  Image,
  Drawer,
  Timeline,
  TimelineItem,
  Avatar,
  InfiniteScroll,
  Empty,
  Skeleton,
  SkeletonItem,
  MessageBox,
  Checkbox,
  Cascader,
  DatePicker,
  Switch
} from 'element-ui'
//封装组件
const element = {
  install: function (Vue) {
      Vue.use(Checkbox)
      Vue.use(Autocomplete)
      Vue.use(Dialog)
      Vue.use(Dropdown)
      Vue.use(DropdownMenu)
      Vue.use(DropdownItem)
      Vue.use(Input)
      Vue.use(Radio)
      Vue.use(RadioGroup)
      Vue.use(RadioButton)
      Vue.use(Select)
      Vue.use(Option)
      Vue.use(OptionGroup)
      Vue.use(Button)
      Vue.use(ButtonGroup)
      Vue.use(Popover)
      Vue.use(Tooltip)
      Vue.use(Form)
      Vue.use(FormItem)
      Vue.use(Tabs)
      Vue.use(TabPane)
      Vue.use(Tag)
      Vue.use(Icon)
      Vue.use(Row)
      Vue.use(Col)
      Vue.use(Upload)
      Vue.use(Badge)
      Vue.use(Card)
      Vue.use(Skeleton)
      Vue.use(SkeletonItem)
      Vue.use(Carousel)
      Vue.use(CarouselItem)
      Vue.use(Divider)
      Vue.use(Image)
      Vue.use(Drawer)
      Vue.use(Timeline)
      Vue.use(TimelineItem)
      Vue.use(Avatar)
      Vue.use(InfiniteScroll)
      Vue.use(Empty)
      Vue.use(Cascader)
      Vue.use(DatePicker)
      // 隐私设置里的开关用到。按需引入模式下漏注册不会报错，只是 <el-switch>
      // 原样留在 DOM 里渲染不出来，很难排查，加新开关时记得回来补这一行。
      Vue.use(Switch)
      Vue.prototype.$confirm = MessageBox.confirm
      // $prompt 之前漏了注册。按需引入模式下 this.$prompt 就是 undefined，
      // 调用直接抛 TypeError，而调用处普遍套着 try/catch（用来吞用户点取消时的 reject），
      // 于是表现成「点了没反应」，非常难查 —— 群设置里的「修改群名」就一直是这个状态。
      Vue.prototype.$prompt = MessageBox.prompt
  }
}
//抛出整体按需引入的组件
export default element
